const nodeURL = process.env.REACT_APP_STRAPI_URL
const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`
})

// Helper function to handle fetch responses with rate limit detection
const handleFetchResponse = async (response) => {
  if (response.status === 429) {
    // Try to parse error message from response body first
    let errorMessage = 'Rate limit exceeded. Please wait a moment and try again.';
    let retryAfter = null;
    
    try {
      // Clone response to read it without consuming the stream
      const clonedResponse = response.clone();
      const errorData = await clonedResponse.json();
      if (errorData.message) {
        errorMessage = errorData.message;
      }
      if (errorData.retryAfter) {
        retryAfter = errorData.retryAfter;
      }
    } catch (e) {
      // If JSON parsing fails, try header
      const headerRetryAfter = response.headers.get('Retry-After');
      if (headerRetryAfter) {
        retryAfter = parseInt(headerRetryAfter, 10);
      }
    }
    
    const error = new Error(errorMessage);
    error.status = 429;
    error.rateLimit = true;
    error.retryAfter = retryAfter;
    throw error;
  }

  if (!response.ok) {
    // Try to get error message from response body
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const clonedResponse = response.clone();
      const errorData = await clonedResponse.json();
      if (errorData.message) {
        errorMessage = errorData.message;
      }
    } catch (e) {
      // Use default message if parsing fails
    }
    
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

// ********** CREATE WORK ITEM  ********** //
export const createWorkitem = async (details) => {
  const opts = {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(details),
  }

  const response = await fetch(`${nodeURL}/workitems`, opts);
  return handleFetchResponse(response);
}

// ********** GET ALL WORK ITEMS  ********** //
export const fetchWorkitems = async () => {
  const opts = {
    method: 'GET',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workitems`, opts);
  return handleFetchResponse(response);
}

// ********** GET A WORK ITEM (BY ID)  ********** //
export const fetchWorkitem = async (id) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workitems/${id}`, opts);
  return handleFetchResponse(response);
}

// ********** GET MULTIPLE WORK ITEMS (BY IDS)  ********** //
export const fetchWorkitemsByIds = async (ids) => {
  if (!ids || ids.length === 0) return [];
  
  const opts = {
    method: 'GET',
    headers: headers(),
  }

  const params = new URLSearchParams();
  ids.forEach((id) => {
    params.append('id_in', id);
  });

  const response = await fetch(`${nodeURL}/workitems?${params.toString()}`, opts);
  
  // Handle rate limit and other errors properly
  try {
    const data = await handleFetchResponse(response);
    // Ensure we return an array even if the response is not an array
    return Array.isArray(data) ? data : [];
  } catch (error) {
    // Re-throw rate limit errors so they can be handled by the caller
    if (error.rateLimit) {
      throw error;
    }
    // For other errors, log and return empty array to prevent crashes
    console.error('Error fetching workitems:', error);
    return [];
  }
}

// ********** UPDATE A WORK ITEM (BY ID)  ********** //
export const updateWorkitem = async (id, details) => {
  const opts = {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(details)
  }

  const response = await fetch(`${nodeURL}/workitems/${id}`, opts);
  return handleFetchResponse(response);
}

// ********** DELETE A WORK ITEM (BY ID)  ********** //
export const deleteWorkitem = async (id) => {
  const opts = {
    method: 'DELETE',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workitems/${id}`, opts);
  return handleFetchResponse(response);
}